import { render, staticRenderFns } from "./view-list.vue?vue&type=template&id=be59c556&scoped=true"
import script from "./view-list.vue?vue&type=script&lang=js"
export * from "./view-list.vue?vue&type=script&lang=js"
import style0 from "./view-list.vue?vue&type=style&index=0&id=be59c556&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be59c556",
  null
  
)

export default component.exports